const TextAreaInput = ({
  label = 'Unknown Label',
  onChange = null,
  value = '',
  placeholder = '',
  inline = false,
  autoFocus = false,
  inputProps = {},
}) => {
  return (
    <div
      className={`px-3 py-2 rounded-xl shadow ${
        inline ? 'flex items-center gap-2' : 'space-y-2'
      }`}
    >
      <label className={`text-gray-700 font-semibold ${!inline && 'block'}`}>
        {label}
      </label>
      <textarea
        className='w-full border-none  resize-none'
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        {...inputProps}
      ></textarea>
    </div>
  );
};

export default TextAreaInput;
